"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightboxProvider = exports.useLightbox = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const Modal_1 = require("../Modal");
const LightboxModal = (0, app_1.styled)(Modal_1.Modal) `
  background: transparent;
  box-shadow: none;
  width: 80%;
  @media ${app_1.mobile} {
    bottom: unset;
  }
`;
const Context = (0, react_1.createContext)(undefined);
function useLightbox(...assetsPaths) {
    const assetsPath = (0, app_1.useAssetsPath)(...assetsPaths);
    const value = (0, react_1.useContext)(Context);
    const show = (img) => {
        value === null || value === void 0 ? void 0 : value.setContext(assetsPath);
        value === null || value === void 0 ? void 0 : value.show(img);
    };
    return value && { show, hide: value.hide };
}
exports.useLightbox = useLightbox;
function LightboxProvider({ children, }) {
    const [img, setImg] = (0, react_1.useState)(undefined);
    const [context, setContext] = (0, react_1.useState)(undefined);
    const show = (0, react_1.useCallback)((newImg) => setImg(newImg), []);
    const hide = (0, react_1.useCallback)(() => setImg(undefined), []);
    const contextValue = (0, react_1.useMemo)(() => ({
        show,
        hide,
        setContext,
    }), [hide, show]);
    return ((0, jsx_runtime_1.jsxs)(Context.Provider, Object.assign({ value: contextValue }, { children: [children, (0, jsx_runtime_1.jsx)(LightboxModal, Object.assign({ options: { showCloseButton: false }, onClose: hide, open: Boolean(img) }, { children: img && ((0, jsx_runtime_1.jsx)(app_1.Image, Object.assign({ img: img }, (context && { context }), { customContext: true, layout: "responsive" }))) }))] })));
}
exports.LightboxProvider = LightboxProvider;
